import React, { useEffect, useRef, useState } from 'react';

const FullPannellumViewer = ({ data }) => {
    const viewerRef = useRef(null);
    const [dimensions, setDimensions] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    useEffect(() => {
        const handleResize = () => {
            setDimensions({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/pannellum@2.5.6/build/pannellum.js';
        script.onload = () => {
            window.pannellum.viewer(viewerRef.current.id, {
                type: 'equirectangular',
                panorama: data.image,
                autoLoad: true,
                pitch: 10,
                yaw: 180,
                hfov: 110,
                showControls: true,
                autoRotate: -3,
            });
        };
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, [data.image]);

    return (
        <>
            <div className="pannellum-container" style={{ position: 'relative' }}>
                <div
                    id="panorama"
                    ref={viewerRef}
                    style={{
                        width: `${dimensions.width}px`,
                        height: `${dimensions.height}px`,
                        margin: '0 auto',
                    }}
                ></div>
                <div
                    style={{
                        position: 'absolute',
                        bottom: '10px',
                        left: '10px',
                        color: '#fff',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        padding: '5px 10px',
                        borderRadius: '5px',
                        fontSize: '14px',
                    }}
                >
                    Design & Developed By: Wolf Studio
                </div>
                <div
                    style={{
                        position: 'absolute',
                        top: '10px',
                        right: '10px',
                    }}
                >
                    <img
                        src={data?.darkLogo || data.logo}
                        alt="Logo"
                        style={{
                            width: '80px',
                            height: 'auto',
                        }}
                    />
                </div>
            </div>
        </>
    );
};

export default FullPannellumViewer;
